import React from "react";
import { useTranslation } from "react-i18next";
import AuthPage from "./AuthPage.jsx";

export default function LoginForm({
  email,
  setEmail,
  password,
  setPassword,
  handleLogin,
  setShowSignUp,
  setShowForgotPassword,
  loginError,
  loginNotice,
}) {
  const { t } = useTranslation();

  const handleSubmit = (event) => {
    event.preventDefault();
    handleLogin();
  };

  const inputClassName =
    "mt-1 block w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 shadow-sm outline-none transition focus:border-sky-600 focus:ring-2 focus:ring-sky-200";

  return (
    <AuthPage title={t("logInTitle")} subtitle={t("loginSubtitle")}>
      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label
            htmlFor="user-email"
            className="text-sm font-medium text-slate-700"
          >
            {t("liEmail")}
          </label>
          <input
            id="user-email"
            type="email"
            autoComplete="email"
            inputMode="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            className={inputClassName}
            required
          />
        </div>
        <div>
          <label
            htmlFor="user-password"
            className="text-sm font-medium text-slate-700"
          >
            {t("liPassword")}
          </label>
          <input
            id="user-password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            className={inputClassName}
            required
          />
        </div>

        {loginError && (
          <p
            role="alert"
            className="rounded-lg bg-red-50 p-3 text-sm text-red-700"
          >
            {loginError}
          </p>
        )}
        {loginNotice && (
          <p
            role="status"
            className="rounded-lg bg-emerald-50 p-3 text-sm text-emerald-700"
          >
            {loginNotice}
          </p>
        )}

        <button
          type="submit"
          className="w-full rounded-lg bg-sky-600 px-4 py-3 font-semibold text-white transition hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-sky-300"
        >
          {t("logInTitle")}
        </button>
        <button
          type="button"
          onClick={setShowSignUp}
          className="w-full rounded-lg border border-sky-600 px-4 py-3 font-semibold text-sky-700 transition hover:bg-sky-50"
        >
          {t("createAcount")}
        </button>
        <button
          type="button"
          onClick={() => setShowForgotPassword(true)}
          className="w-full text-sm font-medium text-sky-700 underline hover:text-sky-900"
        >
          {t("forgot")}
        </button>
      </form>
    </AuthPage>
  );
}
